import Vue from "vue";
import Vuex from "vuex";

import userModule from "./modules/user.js";
import authModule from "./modules/auth.js";
//import wordpressUserModule from "./modules/wordpressUser.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    locale: { text: "Svenska", value: "sv" }
  },
  getters: {
    GET_LOCALE(state) {
      return state.locale;
    }
  },
  mutations: {
    SET_LOCALE(state, payload) {
      state.locale = payload;
    }
  },
  actions: {},
  modules: {
    user: userModule,
    auth: authModule,
    //wordpressUser: wordpressUserModule
  }
});

export default store;
